var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 19,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#131515",
    d: "M.125.313v17.875h13.75V.313H.125ZM1.5 1.688h11v15.124h-11V1.688Zm1.375 1.375v4.124h8.25V3.063h-8.25ZM4.25 4.437h5.5v1.375h-5.5V4.438Zm-.688 4.125v1.376h1.376V8.562H3.563Zm2.75 0v1.376h1.375V8.562H6.313Zm2.75 0v1.376h1.376V8.562H9.062Zm-5.5 2.75v1.376h1.376v-1.376H3.563Zm2.75 0v1.376h1.375v-1.376H6.313Zm2.75 0v1.376h1.376v-1.376H9.062Zm-5.5 2.75v1.376h1.376v-1.376H3.563Zm2.75 0v1.376h1.375v-1.376H6.313Zm2.75 0v1.376h1.376v-1.376H9.062Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.32ffbc53b98ee0eb4969945887289ae8.svg";
export { ForwardRef as ReactComponent };